import { render } from "./Niliopoulou.vue?vue&type=template&id=26267d42"
import script from "./Niliopoulou.vue?vue&type=script&lang=js"
export * from "./Niliopoulou.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__